// Author Shi Wen Long
// Date 2021-08-25 12:04:20

class SithMesPrdSdProjectActivity {
constructor({
        id = null,
        projectDefinition = '',
        wbs = '',
        networkCode = '',
        activity = '',
        decription = '',
        remark = ''}
= {}) {
    this.id = id;
    this.projectDefinition = projectDefinition;
    this.wbs = wbs;
    this.networkCode = networkCode;
    this.activity = activity;
    this.decription = decription;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdSdProjectActivity();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectDefinition',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.grid.projectDefinition',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'wbs',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.grid.wbs',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'networkCode',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.grid.networkCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'activity',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.grid.activity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'decription',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.grid.decription',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    projectDefinitionFilter : "",
    wbsFilter : "",
    networkCodeFilter : "",
    activityFilter : "",
    decriptionFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'projectDefinitionFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.filter.projectDefinition',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'wbsFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.filter.wbs',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'networkCodeFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.filter.networkCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'activityFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.filter.activity',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'decriptionFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.filter.decription',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'projectDefinition',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.entity.projectDefinition',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'wbs',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.entity.wbs',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'networkCode',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.entity.networkCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'activity',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.entity.activity',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'decription',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.entity.decription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdSdProjectActivity.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdSdProjectActivity, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
